import { tUnderConstruction } from './SL00000Sprint00'
import { holiday } from './SL20000Sprint01'
import { renderCalendar, renderFinalExamTimes } from './images/2025-08-fall/render-image'

/*
import { retrospectiveIntroduction } from './SLSprint00'
import { basicSlide, orderedListSlide, tRecap, sprintDemosIntro, sprintDemos } from './SLSprint00'
import { demoAssignment } from './SLSprint00'
import { retrospectiveBreakout } from './SLSprint00'

*/
import { checklistAnnouncementsPreworkAndAgenda, completeDeck, tLab } from './SL00000Sprint00'

// import { tPrework } from './SLSprint00'

import { list61200Sprint07 } from '../ActivityLists/AL61200Sprint07' 

import { tMidtermExamExpectations, tExam } from './SLSprint00'

// Software Architecture (SA) module 7 / sprint 7 global values.
const sprint = 8
const activityList = () => { return list61200Sprint07(sprint) }


const aa_7_1of1_PAaA = {
	'prework':[
		`All sprint ${sprint-1} activities and assignments due Sunday!`, '',
		`Be prepared for Final Exam`,
		`Be prepared for Class Project Presentation Lab` ],
	'announcements':[ 
		'Welcome back!', '',
		`All remaining assignments are due by the end of the day Wednesday` ],
	'agenda':[
		`Final Exam`,
		`Class Project Presentations`,
		`Lab` ]
}

const sprint_xx_class_1 = (activityList, xyz_2_1of1_PAaA, xyz_3_1of1Prework) => { 


	
	const slideDeck = checklistAnnouncementsPreworkAndAgenda(xyz_2_1of1_PAaA, sprint, activityList)
	// const preworkNext = () => { return tPrework('Prework For Next Class', xyz_3_1of1Prework, sprint, activityList) }
	return completeDeck(slideDeck, [ tMidtermExamExpectations, tExam, tLab])
}

const aa_7_1of1 = () => { return sprint_xx_class_1(activityList, aa_7_1of1_PAaA, aa_7_1of1_PAaA.prework) }
const aa_7_2of1 = () => { return [ tUnderConstruction, holiday, renderCalendar, renderFinalExamTimes ] }

export const aa_7_slidedeck = [ aa_7_1of1, aa_7_2of1 ]